<div class="content">
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            ADD - ANIMAL DEATH DETAIL
          </h2>
          <!--<p>Create animal death detail</p>-->
          <a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
            Back
          </a>
        </div>
      </div>
      <br>
      <form class="row" [formGroup]="animal_death">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Date Of Death
              <span style="color: rgb(234, 42, 42); padding-left: 5px;">*</span></label>
            <input type="date" name="deathdate" id="deathdate" value="" class="form-control"
              (change)="deletiondateselect($event)" [(ngModel)]="date_of_death" [ngModelOptions]="{standalone: true}">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="Species Name">Causes Of Death<span
                style="color: rgb(234, 42, 42); padding-left: 5px;">*</span></label>
            <input type="text" id="dathcause" name="dathcause" class="form-control" [(ngModel)]="causes_of_death"
              [ngModelOptions]="{standalone: true}">
            <span class="text-danger" *ngIf="error_flag">Mandatory to fill</span>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <button type="submit" class="btn btn-fill btn-primary mb-3" (click)="AnimalDeath()">Submit<div
              class="ripple-container"></div></button>
          <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>